import { App, Button, Dropdown, type MenuProps } from "antd";
import { IoMdMore } from "react-icons/io";
import { useEffect, useState } from "react";
import { useFetchData as useDownloadFile } from "../../../hooks/useFetch/get";
import { CustomTooltip } from "./remapping.style";

const RemappingTableActions = ({
  fileS3KeyFile,
  fetchRemappingUploadResponse,
}) => {
  const [openMenu, setOpenMenu] = useState(false);
  const { message: messageApi } = App.useApp();

  const [
    fetchFileDownloadUrl,
    {
      isLoading: isLoadingFileDownloadUrl,
      data: fileDownloadUrlData,
      error: fileDownloadUrlError,
      clearError: clearFileDownloadUrlError,
      clearData: clearFileDownloadUrlData,
    },
  ] = useDownloadFile({
    query: "/files/download-url",
    selectData: (data) => data,
  });

  useEffect(() => {
    if (fileDownloadUrlError) {
      messageApi.error(fileDownloadUrlError.message);
      clearFileDownloadUrlError?.();
    }
  }, [fileDownloadUrlError, messageApi]);

  useEffect(() => {
    if (fileDownloadUrlData?.download_url && !isLoadingFileDownloadUrl) {
      window.open(fileDownloadUrlData.download_url, "_blank");
      clearFileDownloadUrlData?.();
    }
  }, [isLoadingFileDownloadUrl, fileDownloadUrlData]);

  const menuItems: MenuProps["items"] = [
    {
      key: "download",
      label: "Download",
      style: { fontWeight: 600, letterSpacing: "0.05em" },
      onClick: () => {
        fetchFileDownloadUrl({ file_key: fileS3KeyFile });
      },
    },
    {
      type: "divider",
    },
    {
      key: "reuse",
      label: "Reuse file",
      style: { fontWeight: 600, letterSpacing: "0.05em" },
      onClick: fetchRemappingUploadResponse,
    },
  ];

  return (
    <CustomTooltip title="Actions" placement="left" color="#f5f5f5" mouseEnterDelay={1.5}>
      <Dropdown
        menu={{ items: menuItems }}
        open={openMenu}
        onOpenChange={setOpenMenu}
        trigger={["click"]}
        placement="rightTop"
        align={{ offset: [6, 4] }}
        overlayStyle={{
          zIndex: 900,
          borderRadius: 6,
          width: 150,
          boxShadow: "0 0 12px 3px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Button
          type="text"
          icon={<IoMdMore size={24} style={{ opacity: !openMenu ? 0.5 : 1 }} />}
          style={{ background: "none" }}
          onClick={(e) => e.stopPropagation()}
        />
      </Dropdown>
    </CustomTooltip>
  );
};

export default RemappingTableActions;
